export const INFINIFI_XYZ_CANONICAL_BASE = "https://app.infinifi.xyz";
export const INFINIFI_TWITTER_X = "https://x.com/infiniFi";
